import RadioButton from "./RadioButton";
import CheckBox from "./CheckBox";
import DropdownFilter from "./DropdownFilter";
import InputIconSearchPanelMultiSelection from "./InputIconSearchPanelMultiSelection";
import Tag from "./Tag";
import { inputOnEnter } from "../js/utils";
import { useEffect, useState } from "react";
import { useOptics } from "../hooks/useOptics";
import DateInput from "./DateInput";

export function DashboardStorePanelFilterSectionOutputSetting({
  typeId,
  onChange,
}) {
  const opticalList = useOptics();
  const [section, setSection] = useState(0);
  const [selectedOpticalList, setSelectedOpticalList] = useState([]);
  const [selectedOptical, setSelectedOptical] = useState({ id: -1, text: "" });
  const [data, setData] = useState({
    salida: typeId !== 3 ? 0 : "",
    agrupadoProveedores: false,
    agrupadoMarcas: false,
    opticas: [],
    aDia: "",
    opticasOrigen: [],
    opticasDestino: [],
  });
  let selectableSection = typeId === 0 || typeId === 3;

  // console.log("DATA: ", data);
  // console.log("section: ", section);

  const clearAll = () => {
    setData({
      salida: 0,
      agrupadoProveedores: false,
      agrupadoMarcas: false,
      opticas: [],
      aDia: "",
      opticasOrigen: [],
      opticasDestino: [],
    });
    setSection(0);
    setSelectedOpticalList([]);
    setSelectedOptical({ id: -1, text: "" });
  };

  useEffect(() => {
    setSection(0);
    setData({
      salida: 0,
      agrupadoProveedores: false,
      agrupadoMarcas: false,
      opticas: [],
      aDia: "",
      opticasOrigen: [],
      opticasDestino: [],
    });
  }, [typeId]);

  useEffect(() => {
    const resetData = {
      agrupadoProveedores: false,
      agrupadoMarcas: false,
      opticas: [],
      aDia: "",
      opticasOrigen: [],
      opticasDestino: [],
    };

    let salida;
    if (section === 0) {
      salida = typeId === 3 ? "" : 0;
    } else if (section === 1) {
      salida = typeId === 0 ? 2 : "";
    }
    setSelectedOpticalList([]);
    setSelectedOptical({ id: -1, text: "" });
    setData({ ...resetData, salida });
  }, [section, typeId]);

  useEffect(() => {
    const selectedIds = opticalList
      .filter((op) => selectedOpticalList.includes(op.text))
      .map((op) => op.id);
    if (typeId === 0) setData((prev) => ({ ...prev, opticas: selectedIds }));
    else if (typeId === 3) {
      if (section === 0)
        setData((prev) => ({ ...prev, opticasDestino: selectedIds }));
      else if (section === 1)
        setData((prev) => ({ ...prev, opticasOrigen: selectedIds }));
    }
  }, [selectedOpticalList]);

  useEffect(() => {
    if (typeId === 0) {
      setData((prev) => ({
        ...prev,
        opticas: selectedOptical.id !== -1 ? [selectedOptical.id] : [],
      }));
    } else if (typeId === 3) {
      if (section === 0) {
        setData((prev) => ({
          ...prev,
          opticasOrigen: selectedOptical.id !== -1 ? [selectedOptical.id] : [],
        }));
      } else if (section === 1) {
        setData((prev) => ({
          ...prev,
          opticasDestino: selectedOptical.id !== -1 ? [selectedOptical.id] : [],
        }));
      }
    }
  }, [selectedOptical]);

  useEffect(() => {
    onChange(data);
  }, [data]);

  return (
    <div className="dashboard-section">
      <div className="dashboard-section-title">
        <div className="opt-table-title opt-table-title-dash-stats">
          Tipo de salida
        </div>
        {typeId <= 3 && (
          <button
            className="cell-label"
            tabIndex={-1}
            style={{ width: "150px" }}
            onClick={clearAll}
          >
            Limpiar selección
          </button>
        )}
      </div>
      <div className="dashboard-sec-row" style={{ gap: 20 }}>
        <div className="dashboard-sec-row">
          <div
            style={{
              width: 30,
              display: "flex",
              justifyContent: "center",
              height: 50,
              alignItems: "center",
            }}
          >
            {selectableSection && (
              <RadioButton
                active={section === 0}
                onClick={() => {
                  setSection(0);
                }}
              ></RadioButton>
            )}
          </div>
          {typeId !== 3 && (
            <div
              className={`rdbtn-selectable opt-table-content grid-5 ${
                selectableSection ? "rdbtn-selectable-border" : ""
              } ${
                section === 0 ? "rdbtn-selectable-on" : "rdbtn-selectable-off"
              }`}
              id="dashboard-output-setting"
            >
              <div className="cell">
                <RadioButton
                  active={data.salida === 0}
                  onClick={() => {
                    if (section === 0) {
                      setData((prev) => ({
                        ...prev,
                        salida: 0,
                      }));
                    }
                  }}
                ></RadioButton>
              </div>
              <div className="cell cell-start-content">
                Individual por óptica
              </div>
              <div className="cell"></div>
              <div className="cell cell-start-content">
                {(typeId === 0 || typeId === 1 || typeId === 2) &&
                  "Agrupado por proveedores"}
              </div>
              <div className="cell">
                {(typeId === 0 || typeId === 1 || typeId === 2) && (
                  <CheckBox
                    active={data.agrupadoProveedores}
                    onClick={() => {
                      if (section === 0) {
                        setData((prev) => ({
                          ...prev,
                          agrupadoProveedores: !data.agrupadoProveedores,
                        }));
                      }
                    }}
                  ></CheckBox>
                )}
              </div>
              <div className="cell">
                {typeId !== 4 && (
                  <RadioButton
                    active={data.salida === 1}
                    onClick={() => {
                      if (section === 0) {
                        setData((prev) => ({
                          ...prev,
                          salida: 1,
                        }));
                      }
                    }}
                  ></RadioButton>
                )}
              </div>
              <div className="cell cell-start-content">
                {typeId !== 4 && "Todas las ópticas"}
              </div>
              <div className="cell"></div>
              <div className="cell cell-start-content">
                {(typeId === 0 || typeId === 1 || typeId === 2) &&
                  "Agrupado por marcas"}
              </div>
              <div className="cell">
                {(typeId === 0 || typeId === 1 || typeId === 2) && (
                  <CheckBox
                    active={data.agrupadoMarcas}
                    onClick={() => {
                      if (section === 0) {
                        setData((prev) => ({
                          ...prev,
                          agrupadoMarcas: !data.agrupadoMarcas,
                        }));
                      }
                    }}
                  ></CheckBox>
                )}
              </div>
            </div>
          )}
          {selectableSection && typeId === 3 && (
            <div
              className={`rdbtn-selectable opt-table-content grid-5 ${
                selectableSection ? "rdbtn-selectable-border" : ""
              } ${
                section === 0 ? "rdbtn-selectable-on" : "rdbtn-selectable-off"
              }`}
              id="dashboard-output-setting-ordes"
            >
              <div className="cell cell-start-content">Origen</div>
              <div className="cell cell-start-content">
                <div className="w-100">
                  <DropdownFilter
                    size={0}
                    disabled={section !== 0}
                    optionList={opticalList.map((e) => ({
                      id: e.id,
                      text: e.text,
                      active: selectedOptical.id === e.id,
                    }))}
                    op={section === 0 ? selectedOptical.text : ""}
                    selectedOptions={[]}
                    onChange={(e) => {
                      setSelectedOptical(e);
                      setSelectedOpticalList((prev) =>
                        prev.filter((text) => text !== e.text),
                      );
                    }}
                  ></DropdownFilter>
                </div>
              </div>
              <div className="cell"></div>
              <div className="cell cell-start-content">Destino</div>
              <div className="cell cell-start-content">
                <InputIconSearchPanelMultiSelection
                  size={0}
                  inactive={section !== 0}
                  type={"type-alphanum-ext"}
                  options={opticalList
                    .filter((e) => e.id !== data.opticasOrigen[0])
                    .map((e) => e.text)}
                  selectedOptions={selectedOpticalList}
                  onChange={(e) => {
                    setSelectedOpticalList(e);
                  }}
                ></InputIconSearchPanelMultiSelection>
              </div>
              {typeId === 3 &&
                section === 0 &&
                selectedOpticalList.length > 0 && (
                  <div
                    className="cell combined-cells-5"
                    style={{
                      flexDirection: "column",
                      alignItems: "flex-start",
                    }}
                  >
                    {selectedOpticalList.length > 0 && (
                      <span style={{ fontWeight: "500", fontSize: 13 }}>
                        Ópticas seleccionadas: {selectedOpticalList.length}
                      </span>
                    )}
                    <div className="tag-content">
                      {selectedOpticalList.map((e, i) => {
                        return (
                          <Tag
                            text={e}
                            key={i}
                            tagId={i}
                            onClick={(e) => {
                              setSelectedOpticalList((prev) =>
                                prev.filter((element) => element !== e),
                              );
                            }}
                          ></Tag>
                        );
                      })}
                    </div>
                  </div>
                )}
            </div>
          )}
        </div>

        <div className="dashboard-sec-row">
          <div
            style={{
              width: 30,
              display: "flex",
              justifyContent: "center",
              height: 50,
              alignItems: "center",
            }}
          >
            {selectableSection && (
              <RadioButton
                active={section === 1}
                onClick={() => {
                  setSection(1);
                }}
              ></RadioButton>
            )}
          </div>
          {selectableSection && typeId === 0 && (
            <div
              className={`rdbtn-selectable opt-table-content grid-7 ${
                selectableSection ? "rdbtn-selectable-border" : ""
              } ${
                section === 1 ? "rdbtn-selectable-on" : "rdbtn-selectable-off"
              }`}
              id="dashboard-output-setting-2"
            >
              <div className="cell combined-cells-3 cell-start-content">
                <div className="data-field">
                  <RadioButton
                    active={data.salida === 2}
                    onClick={() => {
                      if (section === 1) {
                        setSelectedOpticalList([]);
                        setSelectedOptical({ id: -1, text: "" });
                        setData((prev) => ({
                          ...prev,
                          aDia: "",
                          salida: 2,
                        }));
                      }
                    }}
                  ></RadioButton>
                  <span className="label">Valoración global</span>
                </div>
              </div>
              <div className="cell"></div>
              <div className="cell cell-start-content">
                <div className="data-field">
                  <RadioButton
                    active={data.salida === 3}
                    onClick={() => {
                      if (section === 1) {
                        setSelectedOpticalList([]);
                        setData((prev) => ({
                          ...prev,
                          salida: 3,
                        }));
                      }
                    }}
                  ></RadioButton>
                  <span className="label">Calcular stock</span>
                </div>
              </div>
              <div className="cell"></div>
              <div className="cell cell-start-content">
                <div className="data-field" style={{ width: "100%" }}>
                  <span className="label">A dia</span>
                  <DateInput
                    disabled={section !== 1 || data.salida !== 3}
                    max="9999-12-31"
                    className="input-field"
                    value={data.aDia}
                    onChange={(e) => {
                      setData((prev) => ({
                        ...prev,
                        aDia: e.target.value,
                      }));
                    }}
                    onKeyUp={(e) => inputOnEnter(e)}
                  />
                </div>
              </div>
              <div className="cell cell-start-content combined-cells-3">
                <div className="data-field" style={{ width: "100%" }}>
                  <span className="label">Ópticas</span>
                  <InputIconSearchPanelMultiSelection
                    size={0}
                    inactive={section !== 1 || data.salida !== 2}
                    type={"type-alphanum-ext"}
                    options={opticalList.map((e) => e.text)}
                    selectedOptions={selectedOpticalList}
                    onChange={(e) => {
                      setSelectedOpticalList(e);
                    }}
                  ></InputIconSearchPanelMultiSelection>
                </div>
              </div>
              <div className="cell"></div>
              <div className="cell combined-cells-3 cell-start-content">
                <div className="data-field" style={{ width: "100%" }}>
                  <span className="label">Óptica</span>
                  <DropdownFilter
                    size={0}
                    disabled={section !== 1 || data.salida !== 3}
                    optionList={opticalList.map((e) => ({
                      id: e.id,
                      text: e.text,
                      active: selectedOptical.id === e.id,
                    }))}
                    op={selectedOptical.text}
                    selectedOptions={[]}
                    onChange={(e) => {
                      setSelectedOptical(e);
                    }}
                  ></DropdownFilter>
                </div>
              </div>
              {typeId === 0 &&
                section === 1 &&
                selectedOpticalList.length > 0 && (
                  <div
                    className="cell combined-cells-7"
                    style={{
                      flexDirection: "column",
                      alignItems: "flex-start",
                    }}
                  >
                    {selectedOpticalList.length > 0 && (
                      <span style={{ fontWeight: "500", fontSize: 13 }}>
                        Ópticas seleccionadas: {selectedOpticalList.length}
                      </span>
                    )}
                    <div className="tag-content">
                      {selectedOpticalList.map((e, i) => {
                        return (
                          <Tag
                            text={e}
                            key={i}
                            tagId={i}
                            onClick={(e) => {
                              setSelectedOpticalList((prev) =>
                                prev.filter((element) => element !== e),
                              );
                            }}
                          ></Tag>
                        );
                      })}
                    </div>
                  </div>
                )}
            </div>
          )}
          {selectableSection && typeId === 3 && (
            <div
              className={`rdbtn-selectable opt-table-content grid-5 ${
                selectableSection ? "rdbtn-selectable-border" : ""
              } ${
                section === 1 ? "rdbtn-selectable-on" : "rdbtn-selectable-off"
              }`}
              id="dashboard-output-setting-ordes"
            >
              <div className="cell cell-start-content">Origen</div>
              <div className="cell cell-start-content">
                <InputIconSearchPanelMultiSelection
                  size={0}
                  inactive={section !== 1}
                  type={"type-alphanum-ext"}
                  options={opticalList.map((e) => e.text)}
                  selectedOptions={selectedOpticalList}
                  onChange={(e) => {
                    setSelectedOpticalList(e);
                  }}
                ></InputIconSearchPanelMultiSelection>
              </div>
              <div className="cell"></div>
              <div className="cell cell-start-content">Destino</div>
              <div className="cell cell-start-content">
                <div className="w-100">
                  <DropdownFilter
                    size={0}
                    disabled={section !== 1}
                    optionList={opticalList.map((e) => ({
                      id: e.id,
                      text: e.text,
                      active: selectedOptical.id === e.id,
                    }))}
                    op={section === 1 ? selectedOptical.text : ""}
                    selectedOptions={[]}
                    onChange={(e) => {
                      setSelectedOptical(e);
                      setSelectedOpticalList((prev) =>
                        prev.filter((text) => text !== e.text),
                      );
                    }}
                  ></DropdownFilter>
                </div>
              </div>
              {typeId === 3 &&
                section === 1 &&
                selectedOpticalList.length > 0 && (
                  <div
                    className="cell combined-cells-5"
                    style={{
                      flexDirection: "column",
                      alignItems: "flex-start",
                    }}
                  >
                    {selectedOpticalList.length > 0 && (
                      <span style={{ fontWeight: "500", fontSize: 13 }}>
                        Ópticas seleccionadas: {selectedOpticalList.length}
                      </span>
                    )}
                    <div className="tag-content">
                      {selectedOpticalList.map((e, i) => {
                        return (
                          <Tag
                            text={e}
                            key={i}
                            tagId={i}
                            onClick={(e) => {
                              setSelectedOpticalList((prev) =>
                                prev.filter((element) => element !== e),
                              );
                            }}
                          ></Tag>
                        );
                      })}
                    </div>
                  </div>
                )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
